import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["message"];

  connect() {
    this.messageTargets.forEach((message) => {
      this.scheduleDismiss(message);
    });
  }

  dismiss(event) {
    const message =
      event?.currentTarget?.closest("[data-flash-target='message']") ||
      event?.target;
    if (message) {
      this.removeMessage(message);
    }
  }

  scheduleDismiss(message) {
    const dismiss = () => this.removeMessage(message);
    let timeoutId = setTimeout(dismiss, 5000);

    const pause = () => {
      clearTimeout(timeoutId);
    };

    const resume = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(dismiss, 5000);
    };

    message.addEventListener("mouseenter", pause);
    message.addEventListener("mouseleave", resume);
    message.addEventListener("focusin", pause);
    message.addEventListener("focusout", resume);
  }

  removeMessage(message) {
    if (message.classList.contains("is-dismissing")) return;

    message.classList.add("is-dismissing");

    const remove = () => message.remove();
    const fallbackTimer = setTimeout(remove, 350);

    message.addEventListener(
      "transitionend",
      () => {
        clearTimeout(fallbackTimer);
        remove();
      },
      { once: true }
    );
  }
}
